// extracted by mini-css-extract-plugin
export default {"Gallery":"gallery_Gallery__GQ1hA","Header":"gallery_Header__0DGFD"};